export default __webpack_public_path__ + "static/media/link.cd0a94b0.svg";